module Meevo.Plugins.PaymentPlans {
    angular.module('meevo.plugins.paymentPlans', []);
}
